import {
  CancelledError,
  MutationCache,
  QueryCache,
  QueryClient,
} from '@tanstack/react-query';
import { handleHttpError } from './errorHandler';

// meta.toast: false の query・mutation は、失敗してもトーストを出さない（Sentry の規則は同じ）
declare module '@tanstack/react-query' {
  interface Register {
    queryMeta: { toast?: boolean };
    mutationMeta: { toast?: boolean };
  }
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => {
        // 取り消しは失敗ではない。TanStack Query の CancelledError は name が AbortError でないので、handleHttpError では除けない
        if (error instanceof CancelledError) return;
        handleHttpError(error, { toast: query.meta?.toast !== false });
      },
    }),
    mutationCache: new MutationCache({
      onError: (error, _variables, _context, mutation) => {
        handleHttpError(error, { toast: mutation.meta?.toast !== false });
      },
    }),
    defaultOptions: {
      // 今の client と同じく、失敗してもやり直さず、フォーカスでも取り直さない。取り直しの失敗でトーストが出るのも避ける。
      // オフラインでも止めずに送り、今の client と同じく NetworkError ですぐ失敗させる。
      // 止めると、つながり直したときに mutation がまとめて送られ、query も一斉に取り直される
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
        networkMode: 'always',
      },
      mutations: { networkMode: 'always' },
    },
  });
}

// react-on-rails は登録した component ごとに別の React root を作るため、pack の中で 1 つの client を共有する
export const queryClient = createQueryClient();
